// components/ImageModal.jsx
'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import styles from './ImageModal.module.css';
import { Col, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { getFirebaseStorageUrl } from '@/lib/firebaseStorage';

export default function ImageModal({ image, isFullpage, index }) {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const handleDownload = (e) => {
    e.stopPropagation();
    const link = document.createElement('a');
    link.href = getFirebaseStorageUrl(image.image_url);
    link.download = image.caption || image.name || 'image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Col
        key={index}
        xs={12}
        md={4}
        style={{
          padding: '10px',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative', // Ensure badge positions correctly
        }}
        data-aos="zoom-out"
        data-aos-delay={(index + 1) * 50}
        onClick={handleShow}
      >
        {image.featured && <div className={styles.featuredBadge}>Featured</div>}
        <Image
          width={300}
          height={200}
          className={styles.imageGallery}
          alt={image.caption || image.name}
          src={getFirebaseStorageUrl(image.image_url)}
          data-aos="fade-up"
          data-aos-delay={(index + 2) * 50}
        />
        {isFullpage && (
          <div className={styles.galleryCaption}>{image.caption}</div>
        )}
      </Col>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName={styles.modalContent}
        dialogClassName={styles.modalDialog}
        backdropClassName={styles.modalBackdrop}
      >
        <div className={styles.modalContainer} onClick={handleClose}>
          <div
            className={styles.modalContentInner}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalIcons}>
              <FontAwesomeIcon
                icon={faDownload}
                className={styles.icon}
                onClick={handleDownload}
                size="1x"
              />
            </div>
            <Image
              src={getFirebaseStorageUrl(image.image_url)}
              alt={image.caption || image.name}
              width={800}
              height={600}
              className={styles.modalImage}
            />
            {/* Caption removed from modal */}
          </div>
        </div>
      </Modal>
    </>
  );
}
